export default __webpack_public_path__ + "static/goldfilingdust-ad9d671683cf91cd61433485017b2257.png";